import React from "react";
import "../styles/Footer.css";
import { FaInstagram, FaFacebookF, FaLinkedinIn, FaGithub, FaYoutube, FaEnvelope, FaGlobe } from "react-icons/fa";


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p className="footer-text">
          This Website is built by <strong>Ghulam Qadir</strong> 
        </p>
        <p className="footer-text">
           For More Designs Contact
        </p>


        <div className="social-icons">
          <a href="https://www.instagram.com/coreit.tech" target="_blank" rel="noopener noreferrer">
            <FaInstagram />
          </a>
          <a href="https://www.facebook.com/share/1AmgLDUnc9/" target="_blank" rel="noopener noreferrer">
            <FaFacebookF />
          </a>
          <a href="https://www.linkedin.com/in/ghulam-qadir-07a982365/" target="_blank" rel="noopener noreferrer">
            <FaLinkedinIn />
          </a>
          <a href="https://github.com/G-Qadir9988" target="_blank" rel="noopener noreferrer">
            <FaGithub />
          </a>
          <a href="https://youtube.com/@coreittech1?si=JD9vDRG3hOnmfN1j" target="_blank" rel="noopener noreferrer">
            <FaYoutube />
          </a>
          <a href="mailto:gqitspecialist@gmail.com">
            <FaEnvelope />
          </a>
          <a href="https://ghulam-qadir.netlify.app/" target="_blank" rel="noopener noreferrer"><FaGlobe /></a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
